import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Rotas} from 'src/app/core/rotas';
import {BaseService} from '../base/base.service';
import {TipoLancamentoExtrato} from '../../core/tipo-lancamento-extrato';

@Injectable({
    providedIn: 'root'
})
export class TipoLancamentoExtratoService extends BaseService<TipoLancamentoExtrato> {

    constructor(http: HttpClient) {
        super(http, Rotas.TIPOS_LANCAMENTOS_EXTRATO);
    }

    getAll(): Observable<TipoLancamentoExtrato[]> {
        return this.http.get<TipoLancamentoExtrato[]>(Rotas.TIPOS_LANCAMENTOS_EXTRATO);
    }

}
